export const ADVISORY_ROLES = ['admin', 'advisor', 'manager']

export const CLIENT_ROLES = ['customer']

export const checkAdvisoryRole = userRoles => {
  for (const r of userRoles) {
    if (ADVISORY_ROLES.indexOf(r) !== -1) {
      return true
    }
  }
  return false
}
